import { BadgeCheck } from 'lucide-react';

interface VerifiedMemberBadgeProps {
    /** The year the professional's profile went live. */
    yearJoined: string;
}

/** Calculates the number of full years since the given year. */
const getMembershipYears = (yearJoined: string): number =>
    new Date().getFullYear() - Number(yearJoined);

/** Formats the membership duration as a human-readable label. */
const formatMembershipLabel = (years: number): string =>
    years === 1 ? '1 year' : `${String(years)} years`;

/**
 * Displays a trust badge indicating verified ArchiPro membership
 * with the duration and year joined.
 */
const VerifiedMemberBadge = ({ yearJoined }: VerifiedMemberBadgeProps) => {
    const membershipYears = getMembershipYears(yearJoined);
    const membershipLabel = formatMembershipLabel(membershipYears);

    return (
        <div
            className="flex items-center gap-4 bg-[hsl(210_25%_95%)] px-6 py-5"
            data-testid="member-since"
        >
            <BadgeCheck
                className="size-7 shrink-0 text-[hsl(210_30%_40%)]"
                strokeWidth={1.5}
            />
            <div className="flex flex-col gap-0.5">
                <span className="text-sm font-medium uppercase tracking-[0.08em]">
                    Verified ArchiPro Member
                </span>
                <span className="text-sm tracking-[-0.01em] text-gray-500">
                    <span className="font-medium">{membershipLabel}</span>{' '}
                    &middot; Since {yearJoined}
                </span>
            </div>
        </div>
    );
};

export default VerifiedMemberBadge;
